'use strict';
import {module} from '../app';

module.controller('DiagramEditingController', [
    '$scope', '$stateParams', 'diagramEditingModel', '$location', '$rootScope', '$state',
    function ($scope, $stateParams, diagramEditingModel, $location, $rootScope, $state) {
      let id = $stateParams.id;
      let isViewOnly = $location.search().viewOnly;

      $scope.vm = new diagramEditingModel(id, isViewOnly);

      $scope.vm._initWithPatientData($stateParams.ssn, $stateParams.sdate);

      let handle = function (m) {
        $scope.safeApply(function () {
          if ($scope.vm.handlePortalIframeMessage) {
            $scope.vm.handlePortalIframeMessage(m);
          }
        });
      };

      window.removeEventListener("message", handle, false);
      window.addEventListener("message", handle, false);

      let unsubscribeStatusChange = $rootScope.$on('status-change', function (ev, data) {
        $scope.vm.updateOnlineStatus(data);
      });

      $scope.$on('$destroy', function () {
        unsubscribeStatusChange();
        $scope.vm.onDestroy();
      });

    }]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/diagramEditingController.js